import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgParkeerpasAanvragen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#F29FC5"
      d="M32.857 9H7.143C5.959 9 5 9.945 5 11.111V25.89C5 27.055 5.96 28 7.143 28h25.714C34.041 28 35 27.055 35 25.889V11.11C35 9.945 34.04 9 32.857 9"
    />
    <path
      fill="#FADCEB"
      fillRule="evenodd"
      d="M31 13.5h-6v-1h6zM31 16.5h-4v-1h4z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14 11h2c2.76 0 5 2.24 5 5s-2.24 5-5 5h-2v5h-3V11zm0 3v4h2c1.1 0 2-.9 2-2s-.9-2-2-2z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgParkeerpasAanvragen);

export default ForwardRef;
